export function dateCurrent() {
    return ((new Date()).toLocaleDateString('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' }));
}

export function firstDayMonth() {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function dateFirstDayCurrent() {
    return firstDayMonth().toLocaleDateString('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' });
}

// Helpers no formato 'YYYY-MM-DD', usados pelos atalhos de filtro por período (Hoje, Esta semana, etc.)
function toInputDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function todayInputDate() {
    return toInputDate(new Date());
}

export function firstDayOfCurrentMonthInputDate() {
    const now = new Date();
    return toInputDate(new Date(now.getFullYear(), now.getMonth(), 1));
}

export function firstDayOfCurrentYearInputDate() {
    const now = new Date();
    return toInputDate(new Date(now.getFullYear(), 0, 1));
}

export function currentWeekStartInputDate() {
    const now = new Date();
    const dayOfWeek = now.getDay();
    const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
    const monday = new Date(now);
    monday.setDate(now.getDate() + diff);
    return toInputDate(monday);
}